import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'jft-revision-tenders-comparison',
    templateUrl: './revision-tenders-comparison.component.html',
    styleUrls: ['./revision-tenders-comparison.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RevisionTendersComparisonComponent implements OnInit {
    @Input() public previousTender;
    @Input() public tender;
    @Input() public baseCurrency;
    @Input() public baseUnit;
    @Output() onBaseCurrencyChange = new EventEmitter();
    @Output() onBaseUnitChange = new EventEmitter();

    constructor() {
    }

    ngOnInit(): void {
    }

    public baseCurrencyChange(event) {
        this.onBaseCurrencyChange.emit(event);
    }

    public baseUnitChange(event) {
        this.onBaseUnitChange.emit(event);
    }
}
